var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSafetySecurity = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m12 1.219 8.808 3.946v5.872q0 2.678-1.15 5.168a12.7 12.7 0 0 1-3.125 4.18Q14.49 22.171 12 22.781q-2.49-.61-4.533-2.395a12.7 12.7 0 0 1-3.124-4.181 12.2 12.2 0 0 1-1.151-5.168V5.165zM12 12v8.761a8.9 8.9 0 0 0 3.253-1.867 10.8 10.8 0 0 0 2.408-3.1A10.9 10.9 0 0 0 18.835 12zm0 0V3.38L5.165 6.41V12z"
})));
export default SvgSafetySecurity;